import { User, AuthMe } from '@core/models/auth'
import { createAction, props } from '@ngrx/store'

// login action (returnUrl: ruta interna post-login, p. ej. query ?returnUrl=/checkout)
export const login = createAction(
  '[Authentication] Login',
  props<{ username: string; password: string; returnUrl?: string | null }>()
)
export const loginSuccess = createAction(
  '[Authentication] Login Success',
  props<{ user: User; returnUrl?: string | null }>()
)
export const loginFailure = createAction(
  '[Authentication] Login Failure',
  props<{ error: string }>()
)

// logout action
export const logout = createAction('[Authentication] Logout')

export const logoutSuccess = createAction('[Auth] Logout Success')

// clear error (for auto-dismiss toasts or manual close)
export const clearError = createAction('[Authentication] Clear Error')

// me actions
export const loadMe = createAction('[Authentication] Load Me')
export const loadMeSuccess = createAction(
  '[Authentication] Load Me Success',
  props<{ me: AuthMe }>()
)
export const loadMeFailure = createAction(
  '[Authentication] Load Me Failure',
  props<{ error: string }>()
)

// --- Flujo TOTP ---

// Se dispara cuando el login devuelve tempToken en vez de access_token
export const totpChallengeRequired = createAction(
  '[Authentication] TOTP Challenge Required',
  props<{ returnUrl?: string | null }>()
)

// Se dispara desde el componente de "ingresá tu código" al enviar el form
export const verifyTotp = createAction(
  '[Authentication] Verify TOTP',
  props<{ code: string; returnUrl?: string | null }>()
)

export const verifyTotpSuccess = createAction(
  '[Authentication] Verify TOTP Success',
  props<{ user: User; returnUrl?: string | null }>()
)

export const verifyTotpFailure = createAction(
  '[Authentication] Verify TOTP Failure',
  props<{ error: string }>()
)

// --- Flujo de código de respaldo (cuando se perdió el autenticador) ---

// Se dispara desde el mismo componente de "ingresá tu código", cuando el
// usuario elige la opción "usar código de respaldo" en vez del código TOTP.
export const verifyBackupCode = createAction(
  '[Authentication] Verify Backup Code',
  props<{ backupCode: string; returnUrl?: string | null }>()
)

export const verifyBackupCodeSuccess = createAction(
  '[Authentication] Verify Backup Code Success',
  props<{ user: User; returnUrl?: string | null }>()
)

export const verifyBackupCodeFailure = createAction(
  '[Authentication] Verify Backup Code Failure',
  props<{ error: string }>()
)